<template>
	<div class="card animate__animated animate__fadeIn" v-if="active == null">
		<div class="img">
			<img :src="img">
		</div>
		<div class="stick">
		</div>
		<div class="title1">
			<div class="title-content1">{{title}}</div>
		</div>
	</div>
	<div class="card animate__animated animate__fadeIn" v-else-if="!active">
		<div class="img">
			<img :src="img">
		</div>
		<div class="stick2"></div>
		<div class="title1">
			<div class="title-content1">{{title}}</div>
		</div>
	</div>
	<div class="card-active" v-else>
		<div class="card-active-border animate__animated animate__pulse ">
			<div class="card-active-title animate__animated animate__fadeIn ">
				{{title}}
			</div>
			<div class="card-active-stick animate__animated animate__backInUp"></div>
			<div class="card-active-msg animate__animated animate__fadeIn">
				<div class="card-active-msg-row" v-for="i in msg">
					{{i}}
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import 'animate.css'
	export default {
		name: "card",
		props: ['img', 'title', 'active', 'msg'],
		data() {
			return {
				Active: this.active,
				width:document.body.clientWidth
			}
		},
		created(){
			this.width=document.body.clientWidth
		},
		mounted(){
			window.addEventListener('resize', this.handelWidth, false)
			this.handelWidth()
		},
		beforeDestroy(){
			window.removeEventListener("resize",this.handelWidth, false)
		},
		methods:{
			handelWidth(){
				this.width=document.body.clientWidth
				let w=document.body.clientWidth
				let stick=document.getElementsByClassName("stick")
				let stick2=document.getElementsByClassName("stick2")
				if(w<1689){
					stick.forEach(item=>{item.style.left="45%"})
					stick2.forEach(item=>{item.style.left="45%"})
				}else {
					stick.forEach(item=>{item.style.left="47%"})
					stick2.forEach(item=>{item.style.left="47%"})
				}
			}
		}

	}
</script>

<style scoped>
	@keyframes mouseIn {
		0% {
			top: 115px;
		}

		100% {
			top: 50px;
		}
	}

	@keyframes mouseOut {
		0% {
			top: 50px;
		}

		100% {
			top: 115px;
		}
	}

	.card {
		float: left;
		width: 100%;
		/*min-width: 260px;*/
		height: 200px;
		background: #717380;
		opacity: 10;
		/*margin: 10px;*/
	}

	.img {
		/*background: rgb(255, 255, 255);*/
		position: relative;
		top: 50px;
		/*left: 155px;*/
		margin: 0 auto;
		width: 50px;
		height: 50px;
	}

	.stick {
		/*position: absolute;*/
		position: absolute;
		left: 47%;
		width: 32px;
		height: 2px;
		background: rgb(255, 255, 255);
		opacity: 10;
		top: 115px;
	}

	.stick2 {
		position: absolute;
		left: 46%;
		width: 32px;
		height: 2px;
		background: rgb(255, 255, 255);
		opacity: 10;
		top: 115px;
		animation: mouseOut 0.7s;
	}

	.title1 {
		position: absolute;
		width: 100%;
		top: 141px;
	}

	.title-content1 {
		/*left: 140px;*/
		margin: 0 auto;
		position: relative;
		width: 80px;
		height: 27px;
		font-size: 20px;
		font-family: Alibaba PuHuiTi;
		font-weight: 500;
		line-height: 27px;
		color: rgba(255, 255, 255, 1);
		letter-spacing: 0px;
		opacity: 10;
	}

	.card-active {
		float: left;
		width: 100%;
		height: 200px;
		background: rgba(255, 255, 255, 1);
		opacity: 100;
	}

	.card-active-border {
		position: relative;
		top: 5%;
		left: 5%;
		width: 90%;
		height: 180px;
		border: 1px solid rgba(242, 104, 33, 1);
		opacity: 1;
	}

	.card-active-title {
		position: relative;
		top: 39px;
		/*left: 130px;*/
		margin: 0 auto;
		width: 90px;
		height: 27px;
		font-size: 20px;
		font-family: Alibaba PuHuiTi;
		font-weight: 500;
		line-height: 27px;
		color: rgba(242, 104, 33, 1);
		letter-spacing: 2px;
		opacity: 100;
	}

	.card-active-stick {
		position: relative;
		top: 50px;
		/*left: 152px;*/
		margin: 0 auto;
		width: 37px;
		height: 1px;
		background: rgba(242, 104, 33, 1);
		opacity: 1;
		animation: mouseIn 0.7s;
	}

	.card-active-msg {
		position: relative;
		top: 73px;
		/*left: 86px;*/
		margin: 0 auto;
		width: 194px;
		height: 66px;
		font-size: 16px;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
		line-height: 22px;
		color: rgba(242, 104, 33, 1);
		letter-spacing: 2px;
		opacity: 1;
	}

	.card-active-msg-row {
		position: relative;
		width: 100%;
	}
</style>
